module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iMTAiIHZpZXdCb3g9IjAgMCAxMCAxMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxlbGxpcHNlIGN4PSI0LjgxNDM5IiBjeT0iNC44NzUiIHJ4PSIzLjkzOTM5IiByeT0iNCIgc3Ryb2tlPSJ3aGl0ZSIvPg0KPGVsbGlwc2UgY3g9IjQuODE2NzYiIGN5PSI0Ljg3NjU2IiByeD0iMi4zNjM2NCIgcnk9IjIuNCIgZmlsbD0id2hpdGUiLz4NCjwvc3ZnPg0K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/researchCamp/ic_zb.svg
// module id = qOos
// module chunks = 1